import React from "react";
import { getYouTubeEmbedUrl } from "../../API/youtube";

const LiveStreamComp = ({ videoId, title, isLive }) => {
  return (
    <div className={`live-stream-comp ${isLive ? "is-live" : ""}`}>
      <div>
        <iframe
          src={getYouTubeEmbedUrl(videoId)}
          title={title || "YouTube video"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          loading="lazy"
        />
      </div>
      {title && <p className="video-title">{title}</p>}
    </div>
  );
};

export default LiveStreamComp;
